"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2161],{

/***/ 59127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/HomePageLayout/index.tsx + 10 modules
var HomePageLayout = __webpack_require__(22647);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/features/static/GoogleMap.tsx
var GoogleMap = __webpack_require__(54690);
// EXTERNAL MODULE: ./src/constants/company.js
var company = __webpack_require__(81422);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/features/contact/styled.tsx
/* eslint-disable import/prefer-default-export */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px;\n  margin: 50px auto;\n  height: 100%;\n\n  @media ",
        " {\n    padding: 0;\n    max-width: 1300px;\n    width: calc(100% - 150px);\n  }\n}"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 176px;\n  margin-top: 100px;\n  background-color: ",
        ";\n\n  @media ",
        " {\n    height: 260px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  h1 {\n    font-size: 28px;\n\n    @media ",
        " {\n      font-size: 36px;\n    }\n\n    @media ",
        " {\n      font-size: 6.5vh;\n    }\n\n    @media ",
        " {\n      font-size: 44px;\n    }\n  }\n\n  p {\n    font-size: 17px;\n\n    @media ",
        " {\n      font-size: 19px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: 1fr;\n    grid-column-gap: 25px;\n    grid-row-gap: 0px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  margin-bottom: 25px;\n\n  .address {\n    margin: 22px;\n    background: url(",
        "/images/pin.png) no-repeat top left;\n    padding-left: 68px;\n  }\n\n  h5 {\n    font-size: 16px;\n\n    @media ",
        " {\n      font-size: 24px;\n      margin-bottom: 10px;\n    }\n  }\n\n  p {\n    font-size: 14px;\n\n    @media ",
        " {\n      font-size: 18px;\n      margin-bottom: 20px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 40px 30px;\n\n  h5 {\n    font-size: 18px;\n    margin-bottom: 20px;\n    @media ",
        " {\n      font-size: 24px;\n    }\n  }\n\n  p,\n  span {\n    font-size: 14px;\n    margin-bottom: 20px;\n    @media ",
        " {\n      font-size: 18px;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 448px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var Flex = ui/* Common.Flex */.Gn.Flex;
var Container = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-2034a636-0"
})(_templateObject(), ui/* device.tablet */.Uh.tablet);
var Header = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-2034a636-1"
})(_templateObject1(), ui/* color.snow */.$_.snow, ui/* device.tablet */.Uh.tablet);
var HeaderContent = (0,styled_components_browser_esm["default"])(Flex).attrs({
    justify: "center",
    direction: "column"
}).withConfig({
    componentId: "sc-2034a636-2"
})(_templateObject2(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop, ui/* device.laptopL */.Uh.laptopL, ui/* device.tablet */.Uh.tablet);
var ContactContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2034a636-3"
})(_templateObject3(), ui/* device.laptop */.Uh.laptop);
var ContactBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2034a636-4"
})(_templateObject4(), ui/* color.gainsboro */.$_.gainsboro, app/* assetPrefix */.Vc, ui/* device.tablet */.Uh.tablet, ui/* device.tablet */.Uh.tablet);
var ContactInner = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2034a636-5"
})(_templateObject5(), ui/* device.tablet */.Uh.tablet, ui/* device.tablet */.Uh.tablet);
var GoogleMapContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2034a636-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/features/contact/index.tsx







var Text = ui/* Common.Text */.Gn.Text;
var Contact = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomePageLayout["default"], {
        hideStartInvesting: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Contact | Stockbit - Komunitas Saham Indonesia"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                as: "h1",
                                family: "bold",
                                children: "Kontak Kami"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                as: "p",
                                children: "Kirim pertanyaan kamu melalui kontak di bawah ini:"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMapContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMap/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "address",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            as: "h5",
                                            color: ui/* color.primary */.$_.primary,
                                            family: "bold",
                                            children: company/* companyName */.ub
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: company/* address */.Lk
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactInner, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        as: "h5",
                                        family: "bold",
                                        children: "Kontak Utama"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                        as: "p",
                                        children: [
                                            "Untuk segala pertanyaan dan masalah, kamu dapat mengunjungi pusat bantuan kami. Jika kamu membutuhkan bantuan lebih jauh, kamu dapat mengirimkan email ke",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                as: "span",
                                                color: ui/* color.primary */.$_.primary,
                                                children: company/* supportEmail */.sJ
                                            }),
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        as: "h5",
                                        family: "bold",
                                        children: "Kerja Sama Iklan"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                        as: "p",
                                        children: [
                                            "Untuk melakukan kerja sama iklan, kamu dapat mengirimkan proposal penawaran ke",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                as: "span",
                                                color: ui/* color.primary */.$_.primary,
                                                children: company/* marketingEmail */.z8
                                            }),
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        as: "h5",
                                        family: "bold",
                                        children: "Kerja Sama Pers"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                        as: "p",
                                        children: [
                                            "Kamu membutuhkan informasi dari Stockbit? Kirimkan detail informasi yang ingin kamu dapatkan melalui",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                as: "span",
                                                color: ui/* color.primary */.$_.primary,
                                                children: company/* supportEmail */.sJ
                                            }),
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        as: "h5",
                                        family: "bold",
                                        children: "Buka Akun Official di Stockbit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                        as: "p",
                                        children: [
                                            "Jika kamu merupakan bagian dari sebuah perusahaan publik, kamu dapat mengirimkan email ke",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                as: "span",
                                                color: ui/* color.primary */.$_.primary,
                                                children: company/* companyEmail */.uM
                                            }),
                                            " ",
                                            "untuk informasi terkait kerja sama."
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var contact = (Contact);


/***/ })

}]);